import type { SelectOption } from 'BomdisoftComponents/inputs/field/select/render';
import { COUNTRY_DETAILS } from '@bomdisoft/utilities/constants';

export const DEFAULT_PHONE_COUNTRY = 'CM';

export type PhoneParts = { country: string; dial: string; number: string };

export const PHONE_COUNTRY_OPTIONS: readonly SelectOption[] = COUNTRY_DETAILS.map(country => ({ disabled: false, label: `${country.flag} ${country.name} ${country.dial}`, triggerLabel: `${country.flag} ${country.dial}`, value: country.code }));

const dialOf = (code: string) => COUNTRY_DETAILS.find(country => country.code === code)?.dial ?? '';

export const splitPhone = (value: string, preferred: string): PhoneParts => {
  const matches = COUNTRY_DETAILS.filter(country => value.startsWith(country.dial));
  const longest = Math.max(0, ...matches.map(country => country.dial.length));
  const candidates = matches.filter(country => country.dial.length === longest);
  const match = candidates.find(country => country.code === preferred) ?? candidates[0];
  if (match === undefined) return { country: preferred, dial: dialOf(preferred), number: '' };
  return { country: match.code, dial: match.dial, number: value.slice(match.dial.length) };
};

export const joinPhone = (country: string, number: string) => {
  const digits = number.replace(/\D/g, '');
  return digits === '' ? '' : `${dialOf(country)}${digits}`;
};
